<template>
  <div ref="container" class="CarefullyChosenPage container">
    <div class="customTitle">内容精选</div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="list">
        <div
          class="itemBox"
          v-for="(item, index) in h5ContentList"
          :key="index"
        >
          <carefully-chosen-item
            :itemInfo="item"
            class="carefullyChosenItem"
            @linkToDetail="linkToDetailH5Content"
          ></carefully-chosen-item>
        </div>
      </div>
      <template #finished>
        <segement-Line line-text="没有更多数据啦"> </segement-Line>
      </template>
    </van-list>
  </div>
</template>

<script>
import CarefullyChosenItem from "./children/CarefullyChosenItem.vue";
import SegementLine from "@/components/puppetComponent/SegementLine";
import { List } from "vant";
import { mapGetters, mapMutations } from "vuex";
import {
  H5ContentListGet
} from "@/api/souhuo";
export default {
  name: "SouhuoH5Carefullychosenpage",

  data() {
    return {
      page: 1,
      loading: false,
      finished: false,
      h5ContentList: [
      ], // 内容列表
      scrollY: 0
    };
  },

  computed: {
    ...mapGetters(["loginState", "getIsAuthorized", "getIsApp"]),
  },

  components: {
    CarefullyChosenItem,
    SegementLine,
    "van-list": List,
  },

  mounted() {},

  methods: {
    ...mapMutations([
      "AUTHORIZE_POPUP_SHOW",
    ]),
    onLoad() {
      this.GetH5ContentList()
    },
    // 获取内容列表接口
    GetH5ContentList() {
      return H5ContentListGet({ page: this.page })
        .then((res) => {
          this.h5ContentList = [...this.h5ContentList, ...res.DataList];
          this.page++
          this.loading = false;
          if (this.h5ContentList.length >= res.PaginationViewModel.Total) {
            this.finished = true;
          }
        })
        .catch((res) => {
          if (res.ErrMsg) {
            this.$toast(res.ErrMsg);
          }
        });
    },
    linkToDetailH5Content({ id = ''}) {
      if (!this.loginState) {
        this.unLoginModal();
        return;
      }
      this.$router.push({ name: 'carefullyChosenDetail', query: { id: id } })
    },

    unLoginModal() {
      if (!this.getIsAuthorized && this.getIsApp) {
        // 弹出授权登录弹窗
        this.AUTHORIZE_POPUP_SHOW(true);
        return;
      }
      if (this.getIsAuthorized && this.getIsApp) {
        this.$store.commit("LOGINDIALOG_SHOW", true);
        return;
      }
      this.$store.commit("LOGINDIALOG_SHOW", true);
    },
  },

  beforeRouteLeave(to, from, next) {
    let keepAliveRouterList = ['carefullyChosenDetail']
    if (keepAliveRouterList.indexOf(to.name) !== -1) {
      //保存滚动条元素div的scrollTop值
      this.scrollY = this.$refs.container.scrollTop;
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  },

  // 为div元素重新设置保存的scrollTop值
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$nextTick(function () {
        vm.$refs.container.scrollTop = vm.scrollY;
      })
    })
  }
};
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.CarefullyChosenPage {
  .list {
    padding: 0 vw(8);
    box-sizing: border-box;
    .itemBox {
      padding: 0 vw(10);
      box-sizing: border-box;
      background-color: #fff;
      margin-bottom: vw(10);
      &:last-child {
        margin-bottom: 0;
      }
    }
    .carefullyChosenItem {
    }
  }
}
.customTitle {
  position: relative;
  font-size: vw(15);
  font-weight: 700;
  padding: vw(12) 0 vw(12) vw(23);
  box-sizing: border-box;
  &::before {
    position: absolute;
    content: "";
    top: 50%;
    left: 0;
    transform: translate(10px, -50%);
    width: vw(5);
    height: vw(15);
    background: #ff5f5f;
    border-radius: vw(3);
  }
}
</style>